var map = {
	"./App": 49696,
	"./App.vue": 49696,
	"./assets/dark_logo_transparent_background.png": 54560,
	"./assets/dex-icons/Alien.png": 84600,
	"./assets/dex-icons/Ctez.png": 57404,
	"./assets/dex-icons/Dexter.png": 6636,
	"./assets/dex-icons/Flame.png": 66552,
	"./assets/dex-icons/LiquidityBaking.png": 41012,
	"./assets/dex-icons/LiquidityBaking.svg": 16616,
	"./assets/dex-icons/Plenty.png": 10644,
	"./assets/dex-icons/Plenty.svg": 38468,
	"./assets/dex-icons/PlentyNetwork.svg": 54420,
	"./assets/dex-icons/QuipuSwap.png": 33824,
	"./assets/dex-icons/QuipuSwap.svg": 14548,
	"./assets/dex-icons/QuipuSwapV1.svg": 72332,
	"./assets/dex-icons/QuipuswapUpdate.png": 49736,
	"./assets/dex-icons/Sirius.svg": 54972,
	"./assets/dex-icons/Spicy.png": 31292,
	"./assets/dex-icons/Vortex.svg": 78952,
	"./assets/dex-icons/Wtz.png": 10948,
	"./assets/dex-icons/WtzUpdate.png": 7660,
	"./assets/dex-icons/Youves.svg": 29409,
	"./assets/dex-icons/YouvesDark.svg": 72712,
	"./assets/dex-icons/YouvesLight.svg": 72864,
	"./assets/dex-icons/YouvesUpdate.png": 63160,
	"./assets/dex-icons/wtez.png": 46252,
	"./assets/dex-icons/yupana.jpeg": 15216,
	"./assets/discord.svg": 82004,
	"./assets/easy-icon.png": 804,
	"./assets/home-wallet.svg": 9340,
	"./assets/img/alias/0xC0FACE-thumb.jpg": 85372,
	"./assets/img/alias/DY5P1ACE-thumb.jpg": 10240,
	"./assets/img/alias/FCOREBOLLO.png": 9336,
	"./assets/img/alias/Flex_Monument.png": 11112,
	"./assets/img/alias/FloSports.png": 66200,
	"./assets/img/alias/HereAndNowEd4.png": 86448,
	"./assets/img/alias/Kukai-UbisoftQuartz-ProfilPic-white-thumbnail.png": 30812,
	"./assets/img/alias/MarinaAbrabmovicTheHero.jpg": 99352,
	"./assets/img/alias/Parrotz.png": 47400,
	"./assets/img/alias/RichieHawtin.jpg": 34148,
	"./assets/img/alias/TezDev_NFT.png": 46140,
	"./assets/img/alias/VERSA.png": 29568,
	"./assets/img/alias/alchememist.jpg": 71220,
	"./assets/img/alias/alchemy.png": 65164,
	"./assets/img/alias/artcardz.png": 80092,
	"./assets/img/alias/basqunks.png": 45052,
	"./assets/img/alias/bazaar.png": 63908,
	"./assets/img/alias/bazaar.svg": 97828,
	"./assets/img/alias/bluevishnu.jpg": 47624,
	"./assets/img/alias/boomerpunks.png": 90468,
	"./assets/img/alias/boomerpunks2.png": 52692,
	"./assets/img/alias/bunnyknights2ndgen.png": 48868,
	"./assets/img/alias/chopsumo.png": 87204,
	"./assets/img/alias/commonskeles.jpg": 75888,
	"./assets/img/alias/connies-discover.png": 40496,
	"./assets/img/alias/cryptomom.jpeg": 40244,
	"./assets/img/alias/cubeheads.png": 54084,
	"./assets/img/alias/cyber-gecko-gang.png": 99144,
	"./assets/img/alias/cyberkidzclub.png": 91567,
	"./assets/img/alias/decathlon.png": 38668,
	"./assets/img/alias/diplomats.png": 92824,
	"./assets/img/alias/distribconsc.jpg": 12072,
	"./assets/img/alias/dogami-discover.png": 29864,
	"./assets/img/alias/dogami-thumbnail.png": 35912,
	"./assets/img/alias/endlesswaysLogo.png": 56000,
	"./assets/img/alias/filmcrew-discover.png": 27972,
	"./assets/img/alias/filmcrew.png": 28132,
	"./assets/img/alias/flux.png": 16276,
	"./assets/img/alias/formally-verified.png": 37016,
	"./assets/img/alias/fxhash-discover.jpg": 97564,
	"./assets/img/alias/fxhash.svg": 94976,
	"./assets/img/alias/gap-discover.svg": 99392,
	"./assets/img/alias/gap_600x600.png": 17216,
	"./assets/img/alias/gjoe.jpg": 47632,
	"./assets/img/alias/glogang.jpg": 60456,
	"./assets/img/alias/gogo.jpg": 90480,
	"./assets/img/alias/hashthreepoints.png": 4832,
	"./assets/img/alias/hen.png": 64036,
	"./assets/img/alias/hen.svg": 99032,
	"./assets/img/alias/hollows.jpg": 18076,
	"./assets/img/alias/ilmeresh.jpg": 5324,
	"./assets/img/alias/interpop-discover.png": 26912,
	"./assets/img/alias/interpop.svg": 12492,
	"./assets/img/alias/kalamint-thumbnail.png": 7064,
	"./assets/img/alias/kalamint.png": 25916,
	"./assets/img/alias/kalamint.svg": 3984,
	"./assets/img/alias/logoquartz-h-white-color-beta-discover.svg": 69060,
	"./assets/img/alias/mclaren-discover.png": 8284,
	"./assets/img/alias/mclaren-thumbnail.png": 36004,
	"./assets/img/alias/mekatron.jpeg": 22716,
	"./assets/img/alias/minterpop-discover.png": 55412,
	"./assets/img/alias/minterpop.svg": 78400,
	"./assets/img/alias/monarx.jpg": 66916,
	"./assets/img/alias/mooncakes-discover.jpg": 44279,
	"./assets/img/alias/mooncakes.svg": 54409,
	"./assets/img/alias/neonz.jpg": 29496,
	"./assets/img/alias/objktcom.svg": 61720,
	"./assets/img/alias/oneof-discover.svg": 79840,
	"./assets/img/alias/oneof.png": 19964,
	"./assets/img/alias/openminter.svg": 97764,
	"./assets/img/alias/orbix360.png": 36140,
	"./assets/img/alias/orbix360.svg": 4524,
	"./assets/img/alias/ottez.png": 63572,
	"./assets/img/alias/panda.jpeg": 28292,
	"./assets/img/alias/pantone-very-peri.jpg": 97204,
	"./assets/img/alias/pixelpotus.png": 64668,
	"./assets/img/alias/platypoo.jpg": 90383,
	"./assets/img/alias/prjktneon.png": 41764,
	"./assets/img/alias/quartz-demo.svg": 51264,
	"./assets/img/alias/quipu.png": 19156,
	"./assets/img/alias/quipuswap-discover.jpeg": 62884,
	"./assets/img/alias/rarible.png": 7184,
	"./assets/img/alias/salsadao.png": 18788,
	"./assets/img/alias/skele-grid-discover.jpg": 49584,
	"./assets/img/alias/skratz.jpeg": 12812,
	"./assets/img/alias/taconft.png": 71932,
	"./assets/img/alias/taqueria.png": 59584,
	"./assets/img/alias/tezapegang.png": 96053,
	"./assets/img/alias/tezos-campaigns-thumbnail.jpeg": 93356,
	"./assets/img/alias/tezos_blue_bg.jpg": 3916,
	"./assets/img/alias/tezosdomains-discover.png": 26380,
	"./assets/img/alias/tezotopia-discover.png": 73844,
	"./assets/img/alias/tezotopia.png": 428,
	"./assets/img/alias/tezzardz.png": 17528,
	"./assets/img/alias/themoments.jpeg": 93236,
	"./assets/img/alias/tokengesture.png": 28424,
	"./assets/img/alias/transmission.png": 88024,
	"./assets/img/alias/tzcolors.png": 56724,
	"./assets/img/alias/verses-discover.png": 45849,
	"./assets/img/alias/verses.png": 55152,
	"./assets/img/alias/versum.png": 34512,
	"./assets/img/alias/versum.svg": 50140,
	"./assets/img/alias/vesselsgen0.jpg": 76452,
	"./assets/img/alias/vitality.png": 37528,
	"./assets/img/alias/xarb.png": 32492,
	"./assets/img/alias/ziggurats-discover.png": 62736,
	"./assets/img/alias/ziggurats.png": 15172,
	"./assets/img/domain-logo.svg": 68852,
	"./assets/img/spinner/brio.svg": 38256,
	"./assets/img/spinner/default.svg": 42572,
	"./assets/img/spinner/gap.svg": 35760,
	"./assets/img/spinner/gradientSpiral.svg": 47212,
	"./assets/img/spinner/minterPop.svg": 85640,
	"./assets/img/spinner/truesy.svg": 99204,
	"./assets/logo.png": 60656,
	"./assets/logo.svg": 49084,
	"./assets/logo_size.jpg": 1420,
	"./assets/logo_transparent_background.png": 26728,
	"./assets/logos/plenty.svg": 69178,
	"./assets/logos/quipuswap.png": 81075,
	"./assets/logos/spicy.png": 18484,
	"./assets/pixel.png": 1368,
	"./assets/project_images/CryptoEasyLogoLarge.png": 97836,
	"./assets/project_images/EASY.png": 75124,
	"./assets/project_images/GIF.png": 10632,
	"./assets/project_images/GIFLogoLarge.png": 38336,
	"./assets/project_images/Got.png": 53660,
	"./assets/project_images/IDZ.png": 28952,
	"./assets/project_images/PEPE.jpeg": 70436,
	"./assets/project_images/POTUS.png": 95540,
	"./assets/project_images/PepeProject.png": 89640,
	"./assets/project_images/PixelLogoLarge.png": 7708,
	"./assets/project_images/TezIdLogoLarge.png": 71048,
	"./assets/project_images/goeurekalogo.png": 9236,
	"./assets/project_images/vend.png": 4460,
	"./assets/project_images/vendcoin-logo.png": 42716,
	"./assets/projects/GIF": 79608,
	"./assets/projects/GIF.json": 79608,
	"./assets/projects/Pepe": 25072,
	"./assets/projects/Pepe.json": 25072,
	"./assets/projects/Pixel": 93458,
	"./assets/projects/Pixel.json": 93458,
	"./assets/projects/TezId": 83400,
	"./assets/projects/TezId.json": 83400,
	"./assets/projects/Vend": 65240,
	"./assets/projects/Vend.json": 65240,
	"./assets/svg-icons/arrow-right.svg": 84812,
	"./assets/svg-icons/caret-down.svg": 31588,
	"./assets/svg-icons/checkbox.svg": 47004,
	"./assets/svg-icons/coin.svg": 52324,
	"./assets/svg-icons/farm-add.svg": 22229,
	"./assets/svg-icons/lock.svg": 37980,
	"./assets/svg-icons/plus-solid.svg": 60279,
	"./assets/svg-icons/swap-icon.svg": 29788,
	"./assets/svg-icons/unlock.svg": 74295,
	"./assets/svg-icons/vector.svg": 65288,
	"./assets/svg-icons/xtz-crunch.svg": 90992,
	"./assets/taco-card-bg.png": 41264,
	"./assets/tezid.png": 27916,
	"./assets/tezid.svg": 41484,
	"./assets/token-icons/crnchy.png": 51976,
	"./assets/token-tracker-vector.svg": 12500,
	"./assets/white_logo_color_background.jpg": 41148,
	"./assets/white_logo_dark_background.jpg": 39036,
	"./assets/wtz-icon.png": 59396,
	"./components/Bakery": 22904,
	"./components/Bakery.vue": 22904,
	"./components/Banner": 70424,
	"./components/Banner.vue": 70424,
	"./components/ConnectButton": 55696,
	"./components/ConnectButton.vue": 55696,
	"./components/ConnectWallet": 50952,
	"./components/ConnectWallet.vue": 50952,
	"./components/CreateToken": 98648,
	"./components/CreateToken.vue": 98648,
	"./components/CrnchyPrice": 72728,
	"./components/CrnchyPrice.vue": 72728,
	"./components/CrnchyStaking": 31896,
	"./components/CrnchyStaking.vue": 31896,
	"./components/CrnchyStakingCycle/CrnchyStakeInput": 13572,
	"./components/CrnchyStakingCycle/CrnchyStakeInput.vue": 13572,
	"./components/CrnchyStakingCycle/CrnchyStakingDialog": 34128,
	"./components/CrnchyStakingCycle/CrnchyStakingDialog.vue": 34128,
	"./components/CrnchyStakingCycle/CrnchyUnstakeDialog": 12272,
	"./components/CrnchyStakingCycle/CrnchyUnstakeDialog.vue": 12272,
	"./components/CrnchyStakingCycle/Index": 42554,
	"./components/CrnchyStakingCycle/Index.vue": 42554,
	"./components/CrnchyStakingCycle/Unstake": 98828,
	"./components/CrnchyStakingCycle/Unstake.vue": 98828,
	"./components/CrnchyStakingCycle/UnstakeEarly": 86984,
	"./components/CrnchyStakingCycle/UnstakeEarly.vue": 86984,
	"./components/CrunchBurned": 55200,
	"./components/CrunchBurned.vue": 55200,
	"./components/DaasCard": 10612,
	"./components/DaasCard.vue": 10612,
	"./components/FarmCreate": 9436,
	"./components/FarmCreate.vue": 9436,
	"./components/FarmListing": 89356,
	"./components/FarmListing.vue": 89356,
	"./components/FarmListingRow": 48412,
	"./components/FarmListingRow.vue": 48412,
	"./components/FarmStakeDialog": 74940,
	"./components/FarmStakeDialog.vue": 74940,
	"./components/FarmUnstakeDialog": 79120,
	"./components/FarmUnstakeDialog.vue": 79120,
	"./components/FirePit": 3498,
	"./components/FirePit.vue": 3498,
	"./components/Home": 79736,
	"./components/Home.vue": 79736,
	"./components/HomeWallet": 57144,
	"./components/HomeWallet.vue": 57144,
	"./components/HomeWalletPage": 34444,
	"./components/HomeWalletPage.vue": 34444,
	"./components/HomeWalletStats": 85568,
	"./components/HomeWalletStats.vue": 85568,
	"./components/IFO": 3796,
	"./components/IFO.vue": 3796,
	"./components/IFOCard": 3384,
	"./components/IFOCard.vue": 3384,
	"./components/IFOFirst": 93698,
	"./components/IFOFirst.vue": 93698,
	"./components/IFOList": 62464,
	"./components/IFOList.vue": 62464,
	"./components/IFOListRow": 91512,
	"./components/IFOListRow.vue": 91512,
	"./components/IFOTimeBubble": 49144,
	"./components/IFOTimeBubble.vue": 49144,
	"./components/IfoPixelPriv": 75848,
	"./components/IfoPixelPriv.vue": 75848,
	"./components/ImgCache": 32008,
	"./components/ImgCache.vue": 32008,
	"./components/JoinDiscord": 94872,
	"./components/JoinDiscord.vue": 94872,
	"./components/LiquidityWallet": 45344,
	"./components/LiquidityWallet.vue": 45344,
	"./components/LiquidityWalletRow": 30800,
	"./components/LiquidityWalletRow.vue": 30800,
	"./components/Logo": 75536,
	"./components/Logo.vue": 75536,
	"./components/LpLocker": 36292,
	"./components/LpLocker.vue": 36292,
	"./components/LpLockerCreateDialog": 28824,
	"./components/LpLockerCreateDialog.vue": 28824,
	"./components/LpLockerItem": 8376,
	"./components/LpLockerItem.vue": 8376,
	"./components/LpLockerListing": 3716,
	"./components/LpLockerListing.vue": 3716,
	"./components/LpLockerListingRow": 35080,
	"./components/LpLockerListingRow.vue": 35080,
	"./components/LpLockerMyLockers": 32668,
	"./components/LpLockerMyLockers.vue": 32668,
	"./components/LpLockerMyLockersRow": 95402,
	"./components/LpLockerMyLockersRow.vue": 95402,
	"./components/NavMenu": 37177,
	"./components/NavMenu.vue": 37177,
	"./components/NavUtils": 5176,
	"./components/NavUtils.vue": 5176,
	"./components/NavWallet": 55480,
	"./components/NavWallet.vue": 55480,
	"./components/NftAssetCard": 4568,
	"./components/NftAssetCard.vue": 4568,
	"./components/NftCollection": 89280,
	"./components/NftCollection.vue": 89280,
	"./components/NftCollectionsView": 89032,
	"./components/NftCollectionsView.vue": 89032,
	"./components/NftImageSkeleton": 50188,
	"./components/NftImageSkeleton.vue": 50188,
	"./components/NftWalletView": 7696,
	"./components/NftWalletView.vue": 7696,
	"./components/Notice": 49112,
	"./components/Notice.vue": 49112,
	"./components/NumberFormat": 46756,
	"./components/NumberFormat.vue": 46756,
	"./components/NumberTooltip": 94610,
	"./components/NumberTooltip.vue": 94610,
	"./components/Overview": 45932,
	"./components/Overview.vue": 45932,
	"./components/OverviewChart": 34279,
	"./components/OverviewChart.vue": 34279,
	"./components/PortfolioVector": 86880,
	"./components/PortfolioVector.vue": 86880,
	"./components/PortfolioWalletRow": 74884,
	"./components/PortfolioWalletRow.vue": 74884,
	"./components/PriceFormat": 77260,
	"./components/PriceFormat.vue": 77260,
	"./components/RocketSwap": 39816,
	"./components/RocketSwap.vue": 39816,
	"./components/SortArrowIndicator": 84371,
	"./components/SortArrowIndicator.vue": 84371,
	"./components/StakedWallet": 30140,
	"./components/StakedWallet.vue": 30140,
	"./components/StakedWalletRow": 56216,
	"./components/StakedWalletRow.vue": 56216,
	"./components/Suspense": 31456,
	"./components/Suspense.vue": 31456,
	"./components/SvgIcon": 24436,
	"./components/SvgIcon.vue": 24436,
	"./components/Swap": 74324,
	"./components/Swap.vue": 74324,
	"./components/SwapFormFoot": 53376,
	"./components/SwapFormFoot.vue": 53376,
	"./components/SwapFormMain": 40856,
	"./components/SwapFormMain.vue": 40856,
	"./components/SwapRouteItem": 5520,
	"./components/SwapRouteItem.vue": 5520,
	"./components/TablePagination": 271,
	"./components/TablePagination.vue": 271,
	"./components/ToggleTheme": 88584,
	"./components/ToggleTheme.vue": 88584,
	"./components/TokenMetrics": 30504,
	"./components/TokenMetrics.vue": 30504,
	"./components/TokenSelectMenu": 8800,
	"./components/TokenSelectMenu.vue": 8800,
	"./components/TokenTracker": 73220,
	"./components/TokenTracker.vue": 73220,
	"./components/TokenTrackerItem": 59544,
	"./components/TokenTrackerItem.vue": 59544,
	"./components/TokenTrakerRow": 40868,
	"./components/TokenTrakerRow.vue": 40868,
	"./components/Tpl": 13880,
	"./components/Tpl.vue": 13880,
	"./components/TrackerMarkets": 41108,
	"./components/TrackerMarkets.vue": 41108,
	"./components/TrackerOverview": 83768,
	"./components/TrackerOverview.vue": 83768,
	"./components/TrackerOverviewChart": 89440,
	"./components/TrackerOverviewChart.vue": 89440,
	"./components/UsdXtzSwitch": 29888,
	"./components/UsdXtzSwitch.vue": 29888,
	"./components/WtzMain": 40612,
	"./components/WtzMain.vue": 40612,
	"./components/swapConfig": 90336,
	"./components/swapConfig.js": 90336,
	"./crunchy-variables.scss": 22228,
	"./element-variables.scss": 76335,
	"./knownContracts": 30943,
	"./knownContracts.json": 30943,
	"./lib/JsonHelper": 7220,
	"./lib/JsonHelper.js": 7220,
	"./lib/SwapRouter": 83776,
	"./lib/SwapRouter/": 83776,
	"./lib/SwapRouter/DataParsers/dex-indexer-data-parser": 87680,
	"./lib/SwapRouter/DataParsers/dex-indexer-data-parser.js": 87680,
	"./lib/SwapRouter/Dexes": 65880,
	"./lib/SwapRouter/Dexes/": 65880,
	"./lib/SwapRouter/Dexes/Ctez": 33668,
	"./lib/SwapRouter/Dexes/Ctez.js": 33668,
	"./lib/SwapRouter/Dexes/Dexter": 97248,
	"./lib/SwapRouter/Dexes/Dexter.js": 97248,
	"./lib/SwapRouter/Dexes/Flame": 84400,
	"./lib/SwapRouter/Dexes/Flame.js": 84400,
	"./lib/SwapRouter/Dexes/LiquidityBaking": 83560,
	"./lib/SwapRouter/Dexes/LiquidityBaking.js": 83560,
	"./lib/SwapRouter/Dexes/Plenty": 77516,
	"./lib/SwapRouter/Dexes/Plenty.js": 77516,
	"./lib/SwapRouter/Dexes/PlentyCtezTez": 15448,
	"./lib/SwapRouter/Dexes/PlentyCtezTez.js": 15448,
	"./lib/SwapRouter/Dexes/PlentyStable": 10952,
	"./lib/SwapRouter/Dexes/PlentyStable.js": 10952,
	"./lib/SwapRouter/Dexes/PlentyTez": 60080,
	"./lib/SwapRouter/Dexes/PlentyTez.js": 60080,
	"./lib/SwapRouter/Dexes/Quipuswap": 19835,
	"./lib/SwapRouter/Dexes/Quipuswap.js": 19835,
	"./lib/SwapRouter/Dexes/QuipuswapStable": 11176,
	"./lib/SwapRouter/Dexes/QuipuswapStable.js": 11176,
	"./lib/SwapRouter/Dexes/QuipuswapToken2Token": 17776,
	"./lib/SwapRouter/Dexes/QuipuswapToken2Token.js": 17776,
	"./lib/SwapRouter/Dexes/QuipuswapV2": 29437,
	"./lib/SwapRouter/Dexes/QuipuswapV2.js": 29437,
	"./lib/SwapRouter/Dexes/QuipuswapV3": 94144,
	"./lib/SwapRouter/Dexes/QuipuswapV3.js": 94144,
	"./lib/SwapRouter/Dexes/Spicy": 48184,
	"./lib/SwapRouter/Dexes/Spicy.js": 48184,
	"./lib/SwapRouter/Dexes/Vortex": 61844,
	"./lib/SwapRouter/Dexes/Vortex.js": 61844,
	"./lib/SwapRouter/Dexes/Wtz": 54747,
	"./lib/SwapRouter/Dexes/Wtz.js": 54747,
	"./lib/SwapRouter/Dexes/Youves": 8240,
	"./lib/SwapRouter/Dexes/Youves.js": 8240,
	"./lib/SwapRouter/Dexes/Yupana": 18704,
	"./lib/SwapRouter/Dexes/Yupana.js": 18704,
	"./lib/SwapRouter/Dexes/index": 65880,
	"./lib/SwapRouter/Dexes/index.js": 65880,
	"./lib/SwapRouter/SwapRates/amm": 36092,
	"./lib/SwapRouter/SwapRates/amm.js": 36092,
	"./lib/SwapRouter/SwapRates/cfmm/helpers/defaults": 74968,
	"./lib/SwapRouter/SwapRates/cfmm/helpers/defaults.js": 74968,
	"./lib/SwapRouter/SwapRates/cfmm/helpers/math": 97156,
	"./lib/SwapRouter/SwapRates/cfmm/helpers/math.js": 97156,
	"./lib/SwapRouter/SwapRates/cfmm/helpers/swap": 78668,
	"./lib/SwapRouter/SwapRates/cfmm/helpers/swap.js": 78668,
	"./lib/SwapRouter/SwapRates/cfmm/types": 4732,
	"./lib/SwapRouter/SwapRates/cfmm/types.js": 4732,
	"./lib/SwapRouter/SwapRates/cfmm/utils": 67820,
	"./lib/SwapRouter/SwapRates/cfmm/utils.js": 67820,
	"./lib/SwapRouter/SwapRates/flat-cfmm": 6220,
	"./lib/SwapRouter/SwapRates/flat-cfmm.js": 6220,
	"./lib/SwapRouter/SwapRates/plentyStableGeneral": 780,
	"./lib/SwapRouter/SwapRates/plentyStableGeneral.js": 780,
	"./lib/SwapRouter/SwapRates/quipuCurve": 29480,
	"./lib/SwapRouter/SwapRates/quipuCurve.js": 29480,
	"./lib/SwapRouter/SwapRates/tezCtezEstimator": 25176,
	"./lib/SwapRouter/SwapRates/tezCtezEstimator.js": 25176,
	"./lib/SwapRouter/TokenTypes": 27568,
	"./lib/SwapRouter/TokenTypes/": 27568,
	"./lib/SwapRouter/TokenTypes/fa1.2": 35648,
	"./lib/SwapRouter/TokenTypes/fa1.2.js": 35648,
	"./lib/SwapRouter/TokenTypes/fa2": 22936,
	"./lib/SwapRouter/TokenTypes/fa2.js": 22936,
	"./lib/SwapRouter/TokenTypes/index": 27568,
	"./lib/SwapRouter/TokenTypes/index.js": 27568,
	"./lib/SwapRouter/build-operation-params": 65724,
	"./lib/SwapRouter/build-operation-params.js": 65724,
	"./lib/SwapRouter/calculate-price-impact": 46840,
	"./lib/SwapRouter/calculate-price-impact.js": 46840,
	"./lib/SwapRouter/config": 6755,
	"./lib/SwapRouter/config.js": 6755,
	"./lib/SwapRouter/find-best-route": 52404,
	"./lib/SwapRouter/find-best-route.js": 52404,
	"./lib/SwapRouter/index": 83776,
	"./lib/SwapRouter/index.js": 83776,
	"./lib/SwapRouter/utils": 4376,
	"./lib/SwapRouter/utils.js": 4376,
	"./main": 25392,
	"./main.js": 25392,
	"./plugins/axios": 24672,
	"./plugins/axios.js": 24672,
	"./plugins/element": 14896,
	"./plugins/element.js": 14896,
	"./plugins/routes": 88607,
	"./plugins/routes.js": 88607,
	"./store": 33108,
	"./store/": 33108,
	"./store/burnRecord": 10412,
	"./store/burnRecord/": 10412,
	"./store/burnRecord/actions": 5308,
	"./store/burnRecord/actions.js": 5308,
	"./store/burnRecord/index": 10412,
	"./store/burnRecord/index.js": 10412,
	"./store/burnRecord/mutations": 20360,
	"./store/burnRecord/mutations.js": 20360,
	"./store/createToken": 26773,
	"./store/createToken/": 26773,
	"./store/createToken/actions": 52064,
	"./store/createToken/actions.js": 52064,
	"./store/createToken/fa2-defi-fixed-supply": 360,
	"./store/createToken/fa2-defi-fixed-supply.json": 360,
	"./store/createToken/fa2-defi-mintable": 52354,
	"./store/createToken/fa2-defi-mintable.json": 52354,
	"./store/createToken/index": 26773,
	"./store/createToken/index.js": 26773,
	"./store/createToken/mutations": 82920,
	"./store/createToken/mutations.js": 82920,
	"./store/crnchyStaking": 21696,
	"./store/crnchyStaking/": 21696,
	"./store/crnchyStaking/actions": 93532,
	"./store/crnchyStaking/actions.js": 93532,
	"./store/crnchyStaking/getters": 9672,
	"./store/crnchyStaking/getters.js": 9672,
	"./store/crnchyStaking/index": 21696,
	"./store/crnchyStaking/index.js": 21696,
	"./store/crnchyStaking/mutations": 23412,
	"./store/crnchyStaking/mutations.js": 23412,
	"./store/farms": 24184,
	"./store/farms/": 24184,
	"./store/farms/actions": 27088,
	"./store/farms/actions.js": 27088,
	"./store/farms/index": 24184,
	"./store/farms/index.js": 24184,
	"./store/farms/mutations": 84512,
	"./store/farms/mutations.js": 84512,
	"./store/homeWallet": 6784,
	"./store/homeWallet/": 6784,
	"./store/homeWallet/actions": 19112,
	"./store/homeWallet/actions.js": 19112,
	"./store/homeWallet/index": 6784,
	"./store/homeWallet/index.js": 6784,
	"./store/homeWallet/mutations": 37872,
	"./store/homeWallet/mutations.js": 37872,
	"./store/ifo": 61224,
	"./store/ifo/": 61224,
	"./store/ifo/actions": 19864,
	"./store/ifo/actions.js": 19864,
	"./store/ifo/index": 61224,
	"./store/ifo/index.js": 61224,
	"./store/ifo/mutations": 93832,
	"./store/ifo/mutations.js": 93832,
	"./store/ifo/tmp": 37372,
	"./store/ifo/tmp.js": 37372,
	"./store/ifoPixelPriv": 83588,
	"./store/ifoPixelPriv/": 83588,
	"./store/ifoPixelPriv/actions": 71456,
	"./store/ifoPixelPriv/actions.js": 71456,
	"./store/ifoPixelPriv/index": 83588,
	"./store/ifoPixelPriv/index.js": 83588,
	"./store/ifoPixelPriv/mutations": 62548,
	"./store/ifoPixelPriv/mutations.js": 62548,
	"./store/index": 33108,
	"./store/index.js": 33108,
	"./store/lpLockers": 69188,
	"./store/lpLockers/": 69188,
	"./store/lpLockers/actions": 33284,
	"./store/lpLockers/actions.js": 33284,
	"./store/lpLockers/index": 69188,
	"./store/lpLockers/index.js": 69188,
	"./store/lpLockers/mutations": 7060,
	"./store/lpLockers/mutations.js": 7060,
	"./store/rckt": 96772,
	"./store/rckt/": 96772,
	"./store/rckt/actions": 2824,
	"./store/rckt/actions.js": 2824,
	"./store/rckt/index": 96772,
	"./store/rckt/index.js": 96772,
	"./store/rckt/mutations": 1392,
	"./store/rckt/mutations.js": 1392,
	"./store/swap": 88806,
	"./store/swap/": 88806,
	"./store/swap/actions": 65947,
	"./store/swap/actions.js": 65947,
	"./store/swap/default": 39988,
	"./store/swap/default.js": 39988,
	"./store/swap/index": 88806,
	"./store/swap/index.js": 88806,
	"./store/swap/mutations": 72240,
	"./store/swap/mutations.js": 72240,
	"./store/theme": 95520,
	"./store/theme/": 95520,
	"./store/theme/actions": 54776,
	"./store/theme/actions.js": 54776,
	"./store/theme/index": 95520,
	"./store/theme/index.js": 95520,
	"./store/theme/mutations": 63700,
	"./store/theme/mutations.js": 63700,
	"./store/tokenTracker": 22132,
	"./store/tokenTracker/": 22132,
	"./store/tokenTracker/actions": 48552,
	"./store/tokenTracker/actions.js": 48552,
	"./store/tokenTracker/index": 22132,
	"./store/tokenTracker/index.js": 22132,
	"./store/tokenTracker/mutations": 78792,
	"./store/tokenTracker/mutations.js": 78792,
	"./store/usdXtzSwitch": 20021,
	"./store/usdXtzSwitch/": 20021,
	"./store/usdXtzSwitch/actions": 91904,
	"./store/usdXtzSwitch/actions.js": 91904,
	"./store/usdXtzSwitch/index": 20021,
	"./store/usdXtzSwitch/index.js": 20021,
	"./store/usdXtzSwitch/mutations": 6872,
	"./store/usdXtzSwitch/mutations.js": 6872,
	"./store/wallet": 80872,
	"./store/wallet/": 80872,
	"./store/wallet/actions": 2111,
	"./store/wallet/actions.js": 2111,
	"./store/wallet/index": 80872,
	"./store/wallet/index.js": 80872,
	"./store/wallet/mutations": 34360,
	"./store/wallet/mutations.js": 34360,
	"./store/wtz": 82359,
	"./store/wtz/": 82359,
	"./store/wtz/actions": 62672,
	"./store/wtz/actions.js": 62672,
	"./store/wtz/index": 82359,
	"./store/wtz/index.js": 82359,
	"./store/wtz/mutations": 81776,
	"./store/wtz/mutations.js": 81776,
	"./theme.variables.css": 80447,
	"./tokensBlocked": 58192,
	"./tokensBlocked.json": 58192,
	"./tokensUnranked": 91574,
	"./tokensUnranked.json": 91574,
	"./utils": 31528,
	"./utils/": 31528,
	"./utils/coincap": 90015,
	"./utils/coincap.js": 90015,
	"./utils/coingecko": 80152,
	"./utils/coingecko.js": 80152,
	"./utils/dex-indexer": 93512,
	"./utils/dex-indexer.js": 93512,
	"./utils/farm": 64312,
	"./utils/farm.js": 64312,
	"./utils/fire-pit": 61220,
	"./utils/fire-pit.js": 61220,
	"./utils/home-wallet": 78880,
	"./utils/home-wallet-stake": 64467,
	"./utils/home-wallet-stake.js": 64467,
	"./utils/home-wallet.js": 78880,
	"./utils/index": 31528,
	"./utils/index.js": 31528,
	"./utils/ipfs": 12336,
	"./utils/ipfs.js": 12336,
	"./utils/nft-data": 80464,
	"./utils/nft-data.js": 80464,
	"./utils/number-format": 90680,
	"./utils/number-format.js": 90680,
	"./utils/queryDipdup": 37939,
	"./utils/queryDipdup.js": 37939,
	"./utils/quipu": 61179,
	"./utils/quipu.js": 61179,
	"./utils/routing-fee": 47828,
	"./utils/routing-fee.js": 47828,
	"./utils/swapRouterHelper": 67936,
	"./utils/swapRouterHelper.js": 67936,
	"./utils/tezos": 36344,
	"./utils/tezos-domains": 30468,
	"./utils/tezos-domains.js": 30468,
	"./utils/tezos.js": 36344,
	"./utils/teztools": 30736,
	"./utils/teztools-prices": 94680,
	"./utils/teztools-prices.json": 94680,
	"./utils/teztools.js": 30736,
	"./utils/token-tracker": 24192,
	"./utils/token-tracker.js": 24192,
	"./utils/tzkt": 89992,
	"./utils/tzkt.js": 89992,
	"./utils/tzstats": 6192,
	"./utils/tzstats.js": 6192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57616;